import { BaseService } from "core/services";
import { ConfirmingReportRouteService } from "application/confirming-report/services";

class ConfirmingReportService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new ConfirmingReportRouteService());
	}

	uploadReport(resource) {
		const formData = new FormData();
		formData.append("file", resource.file);
		const url = this.routeService.uploadReport(formData);

		return this.apiClient.post(url, formData);
	}
}

export default ConfirmingReportService;